import React from "react";
import { useSelector } from "react-redux";

import { Empty, Table } from "antd";

const ProductOption = ({
  // optionRowSelection,
  optionList,
  handleOptionRowEvent,
  selectedProductRowKeys,
}) => {
  const isLoading = useSelector((state) => state.common.loading);

  const optionColumns = [
    {
      title: "옵션명",
      width: 150,
      dataIndex: "option_title",
      key: "option_title",
      ellipsis: true,
      render: (value) => (
        <p
          style={{
            width: "100%",
            fontSize: "1em",
            margin: 0,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          {value}
        </p>
      ),
    },
    {
      title: "가격",
      width: 100,
      dataIndex: "price_2",
      key: "price_2",
      ellipsis: true,
      render: (value) => {
        return value.toLocaleString();
      },
    },
    {
      title: "박스 당 가격",
      width: 150,
      dataIndex: "option_description",
      key: "option_description",
      ellipsis: true,
    },
    // {
    //     title: '수량',
    //     // width: 200,
    //     // dataIndex: 'option_benefit',
    //     // key: 'option_benefit',
    //     ellipsis: true,
    //     render: (value, record, index) => {
    //         return (
    //             <div>
    //                 <Button
    //                     id="minus"
    //                     onClick={(e) =>
    //                         changeProductQuantity(e, "minus", value, index)
    //                     }
    //                 >-</Button>
    //                 <Button>{value.quantity ? value.quantity : 1}</Button>
    //                 <Button
    //                     id="plus"
    //                     onClick={(e) =>
    //                         changeProductQuantity(e, "plus", value, index)
    //                     }
    //                 >+</Button>
    //             </div>
    //         )
    //     }
    // }
  ];
  return (
    <div className={`order-component-each-detail`}>
      <h4 className={`order-each-detail-title`}>옵션 설정</h4>
      {/*옵션 목록*/}
      <Table
        className="order-create-product-list-table order-create-product-option-list-table"
        // rowSelection={optionRowSelection}
        columns={optionColumns}
        dataSource={optionList.total}
        loading={isLoading}
        bordered
        size="middle"
        rowKey="id"
        rowClassName="coupon-table-row"
        // scroll={{y: 'calc(191px - 48px)'}}
        // scroll={{x: true}}
        onRow={handleOptionRowEvent}
        // tableLayout="auto"
        pagination={false}
        locale={{
          emptyText:
            selectedProductRowKeys?.length !== 0 ? (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  optionList.total?.length === 0
                    ? "선택하신 상품에 등록된 옵션이 없습니다."
                    : optionList.except?.length === 0
                    ? "선택하신 상품에 해당하는 옵션들을 이미 선택하셨습니다."
                    : null
                }
              />
            ) : null,
        }}
      />
    </div>
  );
};
export default ProductOption;
